import ProviderUtilizationPage from './ProviderUtilizationPage';

export default ProviderUtilizationPage;